import {GET_SCHEDULE, HANDLE_SCHEDULE_ERROR} from '../constants';

const initialState = {
	data: null,
	scheduleMap: {},
};

const schedule = (state = initialState, action) => {
	switch (action.type) {
		case GET_SCHEDULE:
			return {
				...state,
				data: action.isThisWeek ? [...action.currentGames] : state.data,
				scheduleMap: {
					[action.scheduleDate]: {
						...state.scheduleMap[action.scheduleDate],
						errorCode: undefined,
						data: [...action.originGames],
					},
				},
			};
		case HANDLE_SCHEDULE_ERROR:
			return {
				...state,
				data: null,
				errorCode: action.errorCode,
				scheduleMap: {
					[action.scheduleDate]: {
						errorCode: action.errorCode,
						data: null,
					},
				},
			};
		default:
			return state;
	}
};

export default schedule;
